<template>
  <v-autocomplete
    label="Filtro por Nível de Estoque"
    :items="items"
    item-text="label"
    item-value="key"
    append-icon="mdi-filter"
    hide-details
    clearable
    multiple
    v-bind="$attrs"
    v-bind:value="modelValue"
    v-on="inputListeners"
  >
    <template v-slot:prepend-item>
      <sys-item-lista-seleciona-tudo
        v-model="selecionaTudo"
        :itens="items"
        valor-chave="key"
        class="pl-2"
      ></sys-item-lista-seleciona-tudo>

      <v-divider />
    </template>

    <template v-slot:selection="{item}">
      <template v-if="modelValue.indexOf(item.key) === 0">
        {{item.label}}
        <span v-if="modelValue.length > 1" class="ml-1 text-gray-200">
          {{`+${modelValue.length - 1}`}}
        </span>
      </template>
    </template>
  </v-autocomplete>
</template>

<script>
import SysItemListaSelecionaTudo from "../../utils/crud/SysItemListaSelecionaTudo";
export default {
  name: "FiltroPorNivelDeEstoque",
  components: {SysItemListaSelecionaTudo},
  model: {
    prop: 'modelValue',
    event: 'update:modelValue'
  },
  props: {
    modelValue: {
      type: [String, Array, Number],
      required: true
    },
    itensObject: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    selecionaTudo: []
  }),
  computed: {
    items() {
      return Object.keys(this.itensObject).map(key => {
        const label = this.itensObject[key]
        return {key, label}
      })
    },
    inputListeners: function () {
      const vm = this

      return Object.assign({},
        vm.$listeners, {
          input: function (values) {
            const valuesValidos = values ? values : ""
            vm.$emit('update:modelValue', valuesValidos)
          }
        }
      )
    }
  },
  watch: {
    selecionaTudo(values) {
      this.$emit('update:modelValue', values)
    }
  }
}
</script>

<style scoped>
</style>
